import Axios from "axios";

const state = () => ({
  feedback: null,
  info: {},
  code: null,
  message: null,
  status: null,
  loading: false,
  host: process.env.VUE_APP_API_HOST || 'http://localhost:8020',
});

const mutations = {
  set_feedback(state, feedback){
    state.feedback = feedback
  },
  set_info(state, info){
    state.info = info
  },
  set_code(state, code){
    state.code = code
  },
  set_message(state, message){
    state.message = message
  },
  set_status(state, status){
    state.status = status
  },
  set_loading(state, loading){
    state.loading = loading
  }
};

const actions = {
  createFeedback({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let url = state.host+"/api/feedback";
      const headers = { Authorization: "Bearer " + localStorage.getItem("token") };

      const data_feedback = {
          "body": payload.body
      }
      
      Axios.post(url, data_feedback, { headers: headers })
        .then((response) => {
          const data_feedback = response.data;

          commit("set_feedback", data_feedback.data);
          commit("set_info", data_feedback.info);
          commit("set_code", response.status);
          commit("set_message", "Feedback created successfully");
          commit("set_status", "success");
          commit("set_loading", false);

          resolve(data_feedback);
        })
        .catch((error) => {
          commit("set_code", error.response ? error.response.status : 500);
          commit("set_message", error.message);
          commit("set_status", "error");
          commit("set_loading", false);
          
          reject(error);
        });
    });
  },
  fetchFeedback({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let url = state.host+"/api/feedback";
      const headers = { Authorization: "Bearer " + localStorage.getItem("token") };
      
      Axios.get(url, { headers: headers })
        .then((response) => {
          const data_feedback = response.data;

          commit("set_feedback", data_feedback.data);
          commit("set_info", data_feedback.info || {});
          commit("set_code", response.status);
          commit("set_message", data_feedback.message || "Feedback fetched successfully");
          commit("set_status", data_feedback.status || "success");
          commit("set_loading", false);
          
          resolve(data_feedback);
        })
        .catch((error) => {
          commit("set_code", error.response ? error.response.status : 500);
          commit("set_message", error.message);
          commit("set_status", "error");
          commit("set_loading", false);
          
          reject(error);
        });
    });
  },
  updateFeedback({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let url = state.host+"/api/feedback/"+payload.id;
      const headers = { Authorization: "Bearer " + localStorage.getItem("token") };

      const data_feedback = {
          "body": payload.body
      }
      
      Axios.put(url, data_feedback, { headers: headers })
        .then((response) => {
          const data_feedback = response.data;

          commit("set_feedback", data_feedback.data);
          commit("set_info", data_feedback.info);
          commit("set_code", response.status);
          commit("set_message", "Feedback created successfully");
          commit("set_status", "success");
          commit("set_loading", false);

          resolve(data_feedback);
        })
        .catch((error) => {
          commit("set_code", error.response ? error.response.status : 500);
          commit("set_message", error.message);
          commit("set_status", "error");
          commit("set_loading", false);
          
          reject(error);
        });
    });
  },
  deleteFeedback({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let url = state.host+'/api/feedback/'+payload.id;
      const headers = { Authorization: "Bearer " + localStorage.getItem("token") };
      
      Axios.delete(url, { headers: headers })
        .then((response) => {
          const data_feedback = response.data;

          commit("set_feedback", data_feedback.data);
          commit("set_info", data_feedback.info);
          commit("set_code", response.status);
          commit("set_message", "Feedback deleted successfully");
          commit("set_status", "success");
          commit("set_loading", false);

          resolve(data_feedback);
        })
        .catch((error) => {
          commit("set_code", error.response ? error.response.status : 500);
          commit("set_message", error.message);
          commit("set_status", "error");
          commit("set_loading", false);
          
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};